import {createReducer, on} from '@ngrx/store';
import {ProduktColumn, ProduktTableState} from '../states/produkt-table.state';
import {ProduktTableActions} from '../actions/produkt-table.actions';
import {ProduktEntitiesActions} from '../actions/produkt-entities.actions';
import {DirectionDTO} from '../../openapi/fakturierung-openapi';


export const initialProduktTableState: ProduktTableState = {
  displayedIds: [],
  tableSettings: {
    _key: 'produkt-table-settings-2025-02-17',
    _columns: [
      {
        id: ProduktColumn.Nummer,
        name: 'Nummer',
        isActive: true,
        width: 96,
        sortable: false,
      }, {
        id: ProduktColumn.Bezeichnung,
        name: 'Produkt',
        isActive: true,
        width: 'allocate',
        overflow: 'ellipsis',
        sortable: false,
      }, {
        id: ProduktColumn.Preis,
        name: 'Preis (Netto)',
        isActive: true,
        alignCell: 'right',
        alignHeader: 'right',
        width: 160,
        sortable: false,
      }, {
        id: ProduktColumn.USt,
        name: 'USt',
        isActive: true,
        alignCell: 'right',
        alignHeader: 'right',
        width: 80,
        sortable: false,
      }, {
        id: ProduktColumn.Actions,
        name: '',
        isActive: true,
        sortable: false,
      },
    ],
    _sortDirs: [],
    _sortParams: [],
  },
  pageableDto: {
    size: 50,
    number: 0,
    property: [
      'nummer',
    ],
    direction: [
      DirectionDTO.Asc,
    ],
  },
  totalPages: 0,
  produkteLoaded: false,
};

export const produktTableReducer = createReducer(
  initialProduktTableState,

  on(ProduktTableActions.setDisplayedIds, (state, {produktDtos}) => ({
      ...state,
      displayedIds: produktDtos.map(produktDto => produktDto.id),
      produkteLoaded: true,
    }),
  ),

  on(ProduktTableActions.clearDisplayedProdukte, (state) => ({
      ...state,
      displayedIds: [],
    }),
  ),

  on(
    ProduktTableActions.changeTableSettings,
    (state, action) => ({
      ...state,
      tableSettings: action.tableSettings,
    })
  ),

  on(
    ProduktTableActions.changePage,
    (state, action) => ({
      ...state,
      pageableDto: {
        ...state.pageableDto,
        ...action.pageableDto,
      },
    })
  ),

  on(
    ProduktEntitiesActions.countProduktePagesSuccess,
    (state, {totalPages}) => ({
      ...state,
      totalPages,
    })
  ),
);
